module.exports = require('./helpers/bundle-url').getBundleURL('k3fDG') + "empty-state-try-screen-3.f68d71bd.mp4";